import { Trans } from 'react-i18next';
import DataCenterSection2Image1 from '../../assets/data_center_section2_image1.png';
import DataCenterSection2Image2Poster from '../../assets/data_center_section2_image2.jpg';
import DataCenterSection2Image2 from '../../assets/data_center_section2_image2.mp4';
import DataCenterSection2Image3 from '../../assets/data_center_section2_image3.png';
import DataCenterSection2Image4 from '../../assets/data_center_section2_image4.png';
import DataCenterSection2Image5 from '../../assets/data_center_section2_image5.png';
import DataCenterSection2Image6 from '../../assets/data_center_section2_image6.png';
import DataCenterSection2Image6Mobile from '../../assets/data_center_section2_image6_mobile.png';
import { CenterLayout, HorizontalLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { Body1, H4, H7, Text4, TitleNormal, TitleNormalBold } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const DataCenterSection2 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(166)}`} />
      <CenterLayout>
        <H4 style={{ textAlign: 'center',
          ...isChina ? {wordBreak: 'break-word'} : {}
         }}><Trans i18nKey='고발열 서버의 안정 운영을 위한 핵심 설비, 비비테크의 모듈형 냉각수 공급라인 및 매니폴드 설계 기술' /></H4>
      </CenterLayout>
      <BTBox height={isMobile ? 24 : `${pxToRem(55)}`} />
      <CenterLayout>
        <Body1 style={{ textAlign: 'center' }}><Trans i18nKey='단순한 제작·납품을 넘어, 성능과 효율을 고려한 맞춤형 설계를 통해 고객의 공정 조건과 요구 사항에 정밀하게 대응합니다.' /></Body1>
      </CenterLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      {isMobile ? (
        <img src={DataCenterSection2Image1} style={{
          width: '100%', height: '540px', objectFit: 'cover',
          objectPosition: 'center',
        }} />
      ) : (
        <img src={DataCenterSection2Image1} style={{ width: '100%' }} />
      )}

      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      <HorizontalLayout style={{ width: '100%', flexDirection: isMobile ? 'column' : 'row', }}>
        <VerticalLayout style={{ flex: 0.5 }}>
          <H7>
            <Trans i18nKey='비비테크 DLC(Direct Liquid Cooling) 냉각설비 기술의 핵심 특징' />
          </H7>
        </VerticalLayout>
        {isMobile ? <BTBox height={24} /> : <BTBox width={50} />}
        <VerticalLayout style={{ flex: 0.5 }}>
          <Text4 style={{
            color: '#979797',
            paddingLeft: '0.9em',
            textIndent: '-0.9em',
            ...isMobile ? { paddingLeft: '0.9em', textIndent: '-0.9em' } : {}
          }}><Trans i18nKey='ㆍDLC 이차 냉각수의 모듈화 설계 기술' /></Text4>
          <Text4 style={{
            color: '#979797',
            paddingLeft: '0.9em',
            textIndent: '-0.9em',
            ...isMobile ? { paddingLeft: '0.9em', textIndent: '-0.9em' } : {}
          }}><Trans i18nKey='ㆍ반도체 라인 특수배관 제작 노하우를 기반으로 한 안정적인 제조 품질' /></Text4>
          <Text4 style={{
            color: '#979797',
            paddingLeft: '0.9em',
            textIndent: '-0.9em',
            ...isMobile ? { paddingLeft: '0.9em', textIndent: '-0.9em' } : {}
          }}><Trans i18nKey='ㆍ3D 모델링을 통한 정밀 설계' /></Text4>
          <Text4 style={{
            color: '#979797',
            paddingLeft: '0.9em',
            textIndent: '-0.9em',
            ...isMobile ? { paddingLeft: '0.9em', textIndent: '-0.9em' } : {}
          }}><Trans i18nKey='ㆍ유동해석(CFD) 기반의 성능 최적화' /></Text4>
          <Text4 style={{
            color: '#979797',
            paddingLeft: '0.9em',
            textIndent: '-0.9em',
            ...isMobile ? { paddingLeft: '0.9em', textIndent: '-0.9em' } : {}
          }}><Trans i18nKey='ㆍ고객 요구에 따른 맞춤 설계 및 제작 서비스' /></Text4>
        </VerticalLayout>
      </HorizontalLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />

      {isMobile ? (
        <video src={DataCenterSection2Image2}
          autoPlay
          muted
          loop
          playsInline
          poster={DataCenterSection2Image2Poster}
          style={{
            width: '100%', height: '400px', objectFit: 'cover',
            objectPosition: 'center',
          }} />
      ) : (
        <video src={DataCenterSection2Image2}
          autoPlay
          muted
          loop
          playsInline
          poster={DataCenterSection2Image2Poster}
          style={{ width: '100%' }} />
      )}

      <BTBox height={isMobile ? 60 : `${pxToRem(127)}`} />
      <CenterLayout>
        <H4 style={{ textAlign: 'center',
          ...isChina ? {wordBreak: 'break-word'} : {}
         }}><Trans i18nKey='CPU의 고성능화 및 AI 연산을 위한 고사양 GPU 적용 확대에 따라, 데이터센터는 고발열 환경에서의 시스템 안정성 확보가 핵심 과제가 되었습니다.' /></H4>
      </CenterLayout>
      <BTBox height={isMobile ? 24 : `${pxToRem(55)}`} />
      <CenterLayout>
        <Body1 style={{ textAlign: 'center' }}><Trans i18nKey='비비테크는 이에 대응하기 위해, DLC(Direct Liquid Cooling) 및 액침냉각(Immersion Cooling) 시스템의 냉각수 계통 분야로 사업을 확장하고 있습니다.' /></Body1>
      </CenterLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(120)}`} />
      <div style={{ width: '100%', backgroundColor: 'black', height: '2px' }}></div>
      <BTBox height={`${pxToRem(16)}`} />
      <H7>
        DLC (Direct Liquid Cooling)
      </H7>
      <BTBox height={`${pxToRem(16)}`} />
      <div style={{ width: '100%', backgroundColor: 'black', height: '0.5px' }}></div>
      <BTBox height={`${pxToRem(40)}`} />
      {isMobile ? (
        <>
          <HorizontalLayout style={{ alignItems: 'center', width: '100%' }}>
            <TitleNormalBold fontSize={12}>
              <Trans i18nKey='냉각방식' />
            </TitleNormalBold>

            <VerticalLayout style={{ marginLeft: 'auto', width: 'auto', flex: '0 0 auto' }}> {/* ✅ 오른쪽 끝으로 */}
              <HorizontalLayout>
                <img src={DataCenterSection2Image3} style={{ width: '167px', height: '111px' }} />
                <BTBox width={4} />
                <img src={DataCenterSection2Image4} style={{ width: '71px', height: '111px' }} />
              </HorizontalLayout>
              <BTBox width={4} />
              <img src={DataCenterSection2Image5} style={{ width: '242px', height: '111px' }} />
            </VerticalLayout>
          </HorizontalLayout>
        </>
      ) : (
        <>
          <HorizontalLayout>
            <TitleNormalBold fontSize={pxToRem(32)}>
              <Trans i18nKey='냉각방식' />
            </TitleNormalBold>
            <div style={{ flex: 1 }}></div>
            <img src={DataCenterSection2Image3} style={{ width: pxToRem(445), height: pxToRem(297) }} />
            <BTBox width={pxToRem(36)} />
            <img src={DataCenterSection2Image4} style={{ width: pxToRem(198), height: pxToRem(297) }} />
            <BTBox width={pxToRem(36)} />
            <img src={DataCenterSection2Image5} style={{ width: pxToRem(445), height: pxToRem(297) }} />
          </HorizontalLayout>
        </>
      )}
      <BTBox height={isMobile ? 16 : `${pxToRem(40)}`} />
      <div style={{ width: '100%', backgroundColor: 'black', height: '0.5px' }}></div>
      <BTBox height={isMobile ? 16 : `${pxToRem(40)}`} />
      <HorizontalLayout style={{
        ...isMobile ? { alignItems: 'center' } : {}
      }}>
        <TitleNormalBold fontSize={isMobile ? 12 : pxToRem(32)} style={{ minHeight: isMobile ? '12px' : '20px' }}>
          <Trans i18nKey='당사 수행 분야' />
        </TitleNormalBold>
        {isMobile ? (
          <>
            <BTBox width={16} />
            <div style={{ flex: 1 }}>
              <TitleNormal fontSize={13} style={{ lineHeight: '20px' }}>
                <Trans i18nKey='데이터센터 & ESS 內 이차 COOLANT 배관 냉각수 분배용 매니폴드' />
              </TitleNormal>
            </div>
          </>
        ) : (
          <>
            <div style={{marginLeft: 'auto', width: pxToRem(890 + 198 + 36 + 36) }}>
              <TitleNormal fontSize={pxToRem(32)}>
                <Trans i18nKey='데이터센터 & ESS 內 이차 COOLANT 배관 냉각수 분배용 매니폴드' />
              </TitleNormal>
            </div>
          </>
        )}
      </HorizontalLayout>
      <BTBox height={isMobile ? 60 : `${pxToRem(120)}`} />

      <div style={{ width: '100%', backgroundColor: 'black', height: '2px' }}></div>
      <BTBox height={isMobile ? 8 : `${pxToRem(16)}`} />
      <H7 style={{
        ...isMobile ? { fontSize: '16px' } : {}
      }}>
        <Trans i18nKey='액침냉각 (Imersion Cooling System)' />
      </H7>
      <BTBox height={isMobile ? 8 : `${pxToRem(16)}`} />
      <div style={{ width: '100%', backgroundColor: 'black', height: '0.5px' }}></div>
      <BTBox height={isMobile ? 16 : `${pxToRem(40)}`} />
      <HorizontalLayout style={{ alignItems: 'center' }}>
        <TitleNormalBold fontSize={isMobile ? 12 : pxToRem(32)}>
          <Trans i18nKey='냉각방식' />
        </TitleNormalBold>
        <div style={{ flex: 1 }}></div>
        {isMobile ? <img src={DataCenterSection2Image6Mobile} style={{ width: '242px' }} /> : <img src={DataCenterSection2Image6} style={{ width: pxToRem(890 + 198 + 36 + 36) }} />}

      </HorizontalLayout>
      <BTBox height={isMobile ? 16 : `${pxToRem(40)}`} />
      <div style={{ width: '100%', backgroundColor: 'black', height: '0.5px' }}></div>
      <BTBox height={isMobile ? 16 : `${pxToRem(40)}`} />
      {isMobile ? (
        <>
          <HorizontalLayout>
            <TitleNormalBold fontSize={isMobile ? 12 : pxToRem(32)}>
              <Trans i18nKey='당사 수행 분야' />
            </TitleNormalBold>
            <BTBox width={16} />
            <div >
              <TitleNormal fontSize={13}>
                <Trans i18nKey='데이터센터 內 Chilled Water배관' />
              </TitleNormal>
            </div>
          </HorizontalLayout>
        </>
      ) : (
        <>
          <HorizontalLayout>
            <TitleNormalBold fontSize={isMobile ? 12 : pxToRem(32)}>
              <Trans i18nKey='당사 수행 분야' />
            </TitleNormalBold>
            <div style={{ flex: 1 }}></div>
            <div style={{ width: pxToRem(890 + 198 + 36 + 36) }}>
              <TitleNormal fontSize={pxToRem(32)}>
                <Trans i18nKey='데이터센터 內 Chilled Water배관' />
              </TitleNormal>
            </div>
          </HorizontalLayout>
        </>
      )}
      <BTBox height={isMobile ? 16 : `${pxToRem(40)}`} />
      <div style={{ width: '100%', backgroundColor: 'black', height: '0.5px' }}></div>
      <BTBox height={isMobile ? 60 : `${pxToRem(436)}`} />
    </VerticalLayout>
  );
};

export default DataCenterSection2;
